import { BaseService } from '../common/service/base.service';

export class BaseContextService extends BaseService {
  constructor(apiVersion: string = 'v1') {
    super(process.env.REACT_APP_CONTEXT_API_URL || '', apiVersion);
  }
}

export class BaseContextServiceV3 extends BaseContextService {
  constructor() {
    super('v3');
  }
}
